import { playVideo as requestVideoPlayback, pauseVideo } from './autoplayVideos.js';

export function serviceCard(scope = document) {
    const sections = scope.querySelectorAll('[data-service-cards]');

    sections.forEach((section) => {
        const cards = [...section.querySelectorAll('[data-service-card]')];
        const mediaItems = [...section.querySelectorAll('[data-service-media]')];

        if (!cards.length) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let activeMedia = null;

        const showMedia = (index, immediate = false) => {
            const nextMedia = mediaItems.find((item) => Number(item.dataset.serviceMedia) === index);

            // Keep the current visual when this service has no media configured.
            if (!nextMedia || nextMedia === activeMedia) return;

            const previousMedia = activeMedia;
            activeMedia = nextMedia;

            mediaItems.forEach((item) => {
                const video = item.querySelector('video');
                if (item !== nextMedia && video) pauseVideo(video);
            });

            const nextVideo = nextMedia.querySelector('video');
            if (nextVideo) requestVideoPlayback(nextVideo);

            if (immediate || reduceMotion) {
                mediaItems.forEach((item) => {
                    const isVisible = item === nextMedia;

                    gsap.set(item, {
                        autoAlpha: isVisible ? 1 : 0,
                        rotation: 0,
                        scale: 1,
                        x: 0,
                        y: 0,
                        zIndex: isVisible ? 2 : 1,
                    });
                });
                return;
            }

            gsap.killTweensOf(mediaItems);

            mediaItems.forEach((item) => {
                if (item === nextMedia || item === previousMedia) return;

                gsap.set(item, {
                    autoAlpha: 0,
                    scale: 1,
                    x: 0,
                    y: 0,
                    rotation: 0,
                    zIndex: 1,
                });
            });

            if (previousMedia) {
                gsap.to(previousMedia, {
                    autoAlpha: 0,
                    yPercent: -75,
                    rotation: -20,
                    scale: 0.72,
                    filter: 'blur(14px)',
                    zIndex: 1,
                    duration: 0.65,
                    ease: 'expo.in',
                });
            }

            gsap.fromTo(nextMedia, {
                autoAlpha: 0,
                x: 0,
                y: 0,
                yPercent: 60,
                scale: 0.72,
                filter: 'blur(14px)',
                rotation: 20,
                zIndex: 2,
            }, {
                autoAlpha: 1,
                yPercent: 0,
                scale: 1,
                filter: 'blur(0px)',
                rotation: 0,
                duration: 0.9,
                ease: 'expo.out',
            });
        };

        if (mediaItems.length) {
            showMedia(Number(mediaItems[0].dataset.serviceMedia), true);
        }

        cards.forEach((card) => {
            const line = card.querySelector('.service-card__line');
            const body = card.querySelector('.service-card__body');
            const index = Number(card.dataset.serviceIndex);
            const cardStickyTop = Number.parseFloat(getComputedStyle(card).top);

            gsap.set(card, { zIndex: index + 1 });

            if (line) {
                if (reduceMotion) {
                    gsap.set(line, { scaleX: 1 });
                } else {
                    gsap.to(line, {
                        scaleX: 1,
                        duration: 0.9,
                        ease: 'power3.out',
                        scrollTrigger: {
                            trigger: card,
                            start: 'top 85%',
                            once: true,
                        },
                    });
                }
            }

            if (body) {
                if (reduceMotion) {
                    gsap.set(body, { autoAlpha: 1, y: 0 });
                } else {
                    gsap.set(body, { autoAlpha: 0, y: 32 });
                    gsap.to(body, {
                        autoAlpha: 1,
                        y: 0,
                        duration: 0.8,
                        ease: 'power3.out',
                        scrollTrigger: {
                            trigger: card,
                            start: 'top 82%',
                            once: true,
                        },
                    });
                }
            }

            ScrollTrigger.create({
                trigger: card,
                start: () => {
                    return Number.isFinite(cardStickyTop)
                        ? `top top+=${cardStickyTop}`
                        : 'top 40%';
                },
                end: 'bottom center',
                onEnter: () => showMedia(index),
                onEnterBack: () => showMedia(index),
                invalidateOnRefresh: true,
            });
        });

        const lastCard = cards.at(-1);

        if (lastCard) {
            const stickyTop = Number.parseFloat(getComputedStyle(lastCard).top) || 0;

            // ScrollTrigger controls the final card so it lands cleanly on its
            // staggered position instead of crossing the preceding card.
            gsap.set(lastCard, { position: 'relative', top: 'auto' });

            ScrollTrigger.create({
                trigger: lastCard,
                start: `top top+=${stickyTop}`,
                end: () => `+=${Math.round(window.innerHeight * 0.06)}`,
                pin: lastCard,
                pinSpacing: true,
                anticipatePin: 1,
                invalidateOnRefresh: true,
            });
        }
    });
}
